<template>
  <auth-container>
    <h2 class="text-2xl mb-4">That didn&rsquo;t work... <router-link class="text-full-blue" to="/account">Try again</router-link></h2>

  </auth-container>
</template>

<script>
 import {mapState, mapActions} from 'vuex';
 import AuthContainer from '@/components/AuthContainer';

 export default {
   data() {
     return {
       success: false
     }
   },
   components: {AuthContainer},
   computed: Object.assign(
     mapState({
       member: state => state.member
     }),
   ),

   async created () {
     this.success = await this.verifyMemberEmail({token: this.$route.params.token});

     if (!!this.member && this.member.email_verified) {
       this.$router.replace({name: 'landing', query: {emailverified: true}});
     }
   },

   methods: {
     ...mapActions(['verifyMemberEmail'])
   },

   watch: {
     success (to, from) {
       if (to) {
         if (this.member) {
           this.$router.replace({name: 'subscribe', query: {emailverified: true}})
         } else {
           this.$router.replace({name: 'login', query: {emailverified: true}})
         }
       }
     },
     member (to) {
       if (to && to.email_verified) {
         this.$router.replace({name: 'landing'});
       }
     }
   }
 }
</script>
